<template>
  <div class="singleDisbursementModal">
    <el-dialog :visible.sync="dialogVisible" class="diglog-card" :title="$t('data.delete_account')" :close-on-click-modal="false" width="509px">
      <div class="header-line" />
      <div class="section-title">
        {{ $t('data.confirm_delete') }}
      </div>
      <div class="section-tip" style="word-break:keep-all;">
        {{ $t('tips.delete_account_tip') }}
      </div>
      <!--
      <div class="section-tip">
        {{ $t('tips.enter_verification_delete_account') }}
      </div>
      <div class="form-container">
        <el-form ref="form" :rules="rule" :model="form" status-icon label-position="top">
          <el-row>
            <el-col :span="24">
              <el-form-item
                :label="$t('system.mfa_verify_code')"
                prop="verify_code">
                <el-input
                  v-model="form.verify_code"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  placeholder="6-digit MFA verification code"
                  @keyup.enter.native="onClickSubmitBtn"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
-->

      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button> -->
        <el-button type="info" :disabled="submiting" class="btn-submit" @click="onClickSubmitBtn">{{ $t('components.submit') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { updatePaymentInfo } from '@/api/online-transaction/online-transaction.js'
// import { fetchDisbursementAllCodeList } from '@/api/components/components.js'
// import { fetchAvailableChannelList } from '@/api/components/components'
import { PostBankDelete } from '@/api/data/data'
export default {
  name: 'Delete_Bank_Account_Modal',
  data() {
    return {
      form: {},
      bankInfo: {},
      dialogVisible: false, // 控制弹框显示隐藏
      submiting: false,
      rule: {
        verify_code: [
          { required: true, message: 'MFA Verification Code cannot be empty', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    // this.getAllChannelList()
  },
  methods: {
    // 改变弹框状态
    showModal(bankInfo) {
      this.dialogVisible = true
      this.bankInfo = bankInfo
      this.form = {}
      // this.$nextTick(() => this.$refs.form.clearValidate())
    },
    onClickSubmitBtn() {
      PostBankDelete({ bank_no: this.bankInfo.bank_no }).then(res => {
        this.$message.success('Success')
        this.dialogVisible = false
        this.$emit('submit')
      }).finally(() => {
        this.submiting = false
      })
      // this.$refs.form.validate((valid) => {
      //   if (valid) {
      //     this.submiting = true
      //     const params = {
      //       verification_code: this.form.verify_code,
      //       bank_no: this.bankInfo.bank_no
      //     }
      //     PostBankDelete(params).then(res => {
      //       this.$message.success('Success')
      //       this.dialogVisible = false
      //       this.$emit('submit')
      //     }).finally(() => {
      //       this.submiting = false
      //     })
      //   }
      // })
    }
  }
}
</script>

<style scoped>
.icon-question{
  position: relative;
  top: -1px;
  margin-left: 5px;
  font-size: 12px;
}
.select-item{
  width: 100%;
}
.tip{
  font-size: 14px;
  font-weight: 400;
  color: #303133;
}
.dialog-footer{
  margin-top: -16px;
  text-align: center;
}
.btn-submit{
  max-width: 500px;
  width: 100%;
  height: 40px;
  border-radius: 4px;
}
</style>
